import React, { useEffect } from "react";

import { useStockPageOptional } from "../lib/StockPage";

/**
 * Loads financial situation data when a stock-page section that needs it mounts
 * (i.e. when the user opens Financial analysis / Financial indicators).
 */
export default function withEnsureFinancialSituation(WrappedComponent) {
  function WithEnsureFinancialSituation(props) {
    const stockPage = useStockPageOptional();
    const loadFinancialSituation = stockPage?.loadFinancialSituation;

    useEffect(() => {
      if (loadFinancialSituation) {
        loadFinancialSituation();
      }
    }, [loadFinancialSituation]);

    return <WrappedComponent {...props} />;
  }

  WithEnsureFinancialSituation.displayName = `withEnsureFinancialSituation(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return WithEnsureFinancialSituation;
}
